export { default as default } from './SearchTabs';
